const FRONTEGG_AFTER_AUTH_REDIRECT_URL = 'FRONTEGG_AFTER_AUTH_REDIRECT_URL';
const authStoreName = 'auth';
const connectivityStoreName = 'connectivity';
const auditsStoreName = 'auditLogs';
const subscriptionsStoreName = 'subscriptions';
const vendorStoreName = 'vendor';

export { FRONTEGG_AFTER_AUTH_REDIRECT_URL as F, authStoreName as a, auditsStoreName as b, connectivityStoreName as c, subscriptionsStoreName as s, vendorStoreName as v };
